import { CALL_API } from "../middleware/api";

export const CLEAN_REPORTS = 'CLEAN_REPORTS';

export const FETCH_POPULAR_SERVICES = 'FETCH_POPULAR_SERVICES';
export const SUCCESS_POPULAR_SERVICES = 'SUCCESS_POPULAR_SERVICES';
export const FAILURE_POPULAR_SERVICES = 'FAILURE_POPULAR_SERVICES';

export const FETCH_ORDERS_REPORT = 'FETCH_ORDERS_REPORT';
export const SUCCESS_ORDERS_REPORT = 'SUCCESS_ORDERS_REPORT';
export const FAILURE_ORDERS_REPORT = 'FAILURE_ORDERS_REPORT';

export const FETCH_CATEGORY_CLICKS = 'FETCH_CATEGORY_CLICKS';
export const SUCCESS_CATEGORY_CLICKS = 'SUCCESS_CATEGORY_CLICKS';
export const FAILURE_CATEGORY_CLICKS = 'FAILURE_CATEGORY_CLICKS';

export function getPopularServicesReport(data) {
    return {
        type: FETCH_POPULAR_SERVICES,
        [CALL_API]: {
            endpoint: `/api/report/services/popular`,
            method: 'post',
            types: [SUCCESS_POPULAR_SERVICES, FAILURE_POPULAR_SERVICES],
            data
        }
    }
}

export function getOrdersReport(data) {
    return {
        type: FETCH_ORDERS_REPORT,
        [CALL_API]: {
            endpoint: '/api/report/orders',
            method: 'post',
            types: [SUCCESS_ORDERS_REPORT, FAILURE_ORDERS_REPORT],
            data
        }
    }
}

export function getCategoryClicks(data) {
    return {
        type: FETCH_CATEGORY_CLICKS,
        [CALL_API]: {
            endpoint: `/api/report/categories/clicks`,
            method: 'post',
            types: [SUCCESS_CATEGORY_CLICKS, FAILURE_CATEGORY_CLICKS],
            data      
        }
    }
}

export function cleanReports() {
    return { type: CLEAN_REPORTS };
}


// WEBPACK FOOTER //
// ./src/actions/reports.js